import styled from '@emotion/styled';

export const Container = styled.div`
  margin: auto;
  width: '100%';
  max-width: 1024px;
  padding: 48px 16px;

  .attribution {
    margin-top: 24px;
  }
`;
